import React from 'react';
import { Box, Button } from '@mui/material';
import { DiscoveryViewMode } from '../constants/discoveryViewMode';

interface DiscoveryViewToggleProps {
  viewMode: DiscoveryViewMode;
  onChange: (mode: DiscoveryViewMode) => void;
}

/** FEAT-085 — Faces/Cards toggle shared by search and Saved Caregivers. */
const DiscoveryViewToggle: React.FC<DiscoveryViewToggleProps> = ({
  viewMode,
  onChange,
}) => (
  <Box display="flex" gap={1} role="group" aria-label="Discovery view">
    <Button
      variant={viewMode === 'faces' ? 'contained' : 'outlined'}
      size="small"
      onClick={() => onChange('faces')}
      data-testid="discovery-view-faces"
    >
      Faces
    </Button>
    <Button
      variant={viewMode === 'cards' ? 'contained' : 'outlined'}
      size="small"
      onClick={() => onChange('cards')}
      data-testid="discovery-view-cards"
    >
      Cards
    </Button>
  </Box>
);

export default DiscoveryViewToggle;
